<template>
    <div class="card card-info" id="divEmployeeList">
        <div class="card-header">
            <a href="../Students/Create" class="btn btn-sm btn-outline-secondary btn-default"><i class="fa fa-plus text-black-50"> <b>Add New</b></i></a>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive-sm">
                        <table id="studentTable" style="width: 100%" class="table table-bordered table-sm">
                            <thead class="bg-info">
                                <tr>
                                    <th>Department</th>
                                    <th>Program</th>
                                    <th>Session</th>
                                    <th>Section</th>
                                    <th>Reg No.</th>
                                    <th>From No.</th>
                                    <th>Roll No.</th>
                                    <th>Student Name</th>
                                    <th>Father Name</th>
                                    <th>CNIC</th>
                                    <th>Reg. Date</th>
                                    <th style="width: 10px;"></th>
                                </tr>
                            </thead>
                            <tbody></tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>export default ({
        data() {
            return {
                studentID: 0,
            }
        },

        created: function () {

        },
        methods: {

        }
    })

    $(document).ready(function () {

        if (!$.fn.dataTable.isDataTable('#studentTable')) {
            var table = $('#studentTable').DataTable({

                "processing": true,
                "serverSide": true,
                "filter": true,
                "ajax": {
                    "url": "/api/StudentsApi/studentList",
                    "type": "POST",
                    "datatype": "json"
                },
                "columnDefs": [
                    {
                        "targets": [0],
                        "visible": false,
                        "searchable": false
                    },
                    //{
                    //    targets: 6,
                    //    render: $.fn.dataTable.render.number('','',0,'')
                    //}
                ],
                "columns": [
                    { "data": "DepartmentName", "name": "DepartmentName", "autoWidth": true },
                    { "data": "ProgramName", "name": "ProgramName", "autoWidth": true },
                    { "data": "SessionName", "name": "SessionName", "autoWidth": true },
                    { "data": "SectionName", "name": "SectionName", "autoWidth": true },
                    { "data": "RegistrationNo", "name": "RegistrationNo", "autoWidth": true },
                    { "data": "FormNo", "name": "FormNo", "autoWidth": true },
                    { "data": "RollNo", "name": "RollNo", "autoWidth": true },
                    { "data": "Name", "name": "Name", "autoWidth": true },
                    { "data": "FathersName", "name": "FathersName", "autoWidth": true },
                    { "data": "CNIC", "name": "CNIC", "autoWidth": true },
                    { "data": "RegistrationDate", "name": "RegistrationDate", "autoWidth": true },
                    {
                        "render": function (data, type, row, meta) {
                            return actions(data, type, row, meta);
                        }
                    },
                ]
            });
        }

        function actions(data, type, row, meta) {
            return "<a href='../Students/Create?id=" + row.ID + "' target='_blank' class='btn btn-primary' id='" + row.ID + "' onclick='edit(" + row.ID + ")'>Edit</a>" +
                "<a href='../Students/Print?id=" + row.ID + "' target='_blank' class='btn btn-primary' id='" + row.ID + "' onclick='edit(" + row.ID + ")'>Print</a>"
        }



        //$('.dataTables_filter input')
        //  .unbind('keypress keyup')
        //  .bind('keypress keyup', function (e) {
        //    if ($(this).val().length < 3 && e.keyCode != 13) return;
        //    table.fnFilter($(this).val());
        //  });
    });</script>



// WEBPACK FOOTER //
// src/components/DC/allStudentsForm.vue